import React from "react"
import ShowBreakdown from "./breakdown"

var new_tax = 0, new_saving = 0, new_investment = 0, new_expense = 0

function Tracker() {

  const [value, setValue] = React.useState("")
  const [tag, setTag] = React.useState("")
  const [tax, setTax] = React.useState("")
  const [saving, setSaving] = React.useState("")
  const [expense, setExpense] = React.useState("")
  const [investment, setInvestment] = React.useState("")

  function handleClick() {

    if (tag === "tax") {
      new_tax += (Number(value))
      setTax(new_tax)
    } else if (tag === "saving") {
      new_saving += (Number(value))
      setSaving(new_saving)
    } else if (tag === "investment") {
      new_investment += (Number(value))
      setInvestment(new_investment)
    } else if (tag === "expense") {
      new_expense += (Number(value))
      setExpense(new_expense)
    }
    
  }

  return (
    <div className="user-tracker">

      <h3>Track Down Your Own Expense</h3>
      <p>Here you can add and track all of your expenses and investments and see the overall outcomes.</p>

      <input
        className="form-control input"
        type="number"
        placeholder="Enter Amount Here"
        onChange={(event) => setValue(event.target.value)}
        value={value}
      />

      <select className="form-select input" onChange={(event) => setTag(event.target.value)}>
        <option>Select Category</option>
        <option value="tax">Tax</option>
        <option value="saving">Savings</option>
        <option value="investment">Investments</option>
        <option value="expense">Expense</option>
      </select>

      <button className="btn btn-primary add" onClick={handleClick}>Add</button>

      <ShowBreakdown
        tax={(Math.round(tax * 100) / 100).toFixed(2)}
        investment={(Math.round(investment * 100) / 100).toFixed(2)}
        saving={(Math.round(saving * 100) / 100).toFixed(2)}
        expense={(Math.round(expense * 100) / 100).toFixed(2)}
      />

    </div>
  )
}

export default Tracker
